import { IndicatorComponentType } from 'react-select/src/components';
import React from 'react';
import { OptionTypeBase } from 'react-select';
import styled from 'styled-components';
import { useMixin } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { theme } from '../theme';

const ClearIcon = styled(Icon)`
  margin-right: ${theme.clearIcon.margin.right};
  cursor: pointer;
`;

export const ClearIndicator: IndicatorComponentType<OptionTypeBase> = (props) => {
  const color = useMixin(theme.clearIcon.color);
  return <ClearIcon name="cancel" size="md" color={color} {...props.innerProps} />;
};
